import { reaction } from 'mobx';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { ISwitchPageMonitor } from './switch-page-monitor.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { ElementsAnalyze } from '@src/slide/domain/ui-model/element-modeles/elements-analysis';

declare global {
    interface Window {
        performance: {
            mask(markString: string): void;
        };
    }
}

export default class SwitchPageMonitor implements ISwitchPageMonitor {
    private costTime;
    private selectionServiceDelegate: ISelectionService | undefined;

    public constructor(selectionService?: ISelectionService) {
        this.costTime = {
            pageKey: null,
            baseElementCount: 0,
            jsDuration: 0,
            taskDuration: 0,
        };

        if (selectionService) {
            this.setSelectionServiceDelegate(selectionService);
        }
    }

    public setSelectionServiceDelegate(selectionService: ISelectionService): void {
        if (this.selectionServiceDelegate) return;
        this.selectionServiceDelegate = selectionService;
        this.observeSlideIndexChange(selectionService);
        this.observeLongtask();
    }

    public end(key): void {
        if (this.costTime.pageKey === key) {
            // if (window.performance?.mark) {
            //     window.performance.mark('switchPageEnd');
            // }
        }
    }

    private observeLongtask = () => {
        if ('PerformanceObserver' in window) {
            const observer = new PerformanceObserver((list) => {
                const entries = list.getEntries() || [];

                let switchEntry;
                let beginEntry;
                let endEntry;
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < entries.length; i++) {
                    const entry = entries[i];
                    if (entry.entryType === 'longtask') {
                        switchEntry = entry;
                    } else if (entry.name === 'switchPageBegin') {
                        beginEntry = entry;
                    } else if (entry.name === 'switchPageEnd') {
                        endEntry = entry;
                        if (beginEntry && endEntry) {
                            this.costTime.jsDuration = endEntry.startTime - beginEntry.startTime;
                            if (switchEntry) {
                                this.costTime.taskDuration = switchEntry.duration;
                                // 上报切页耗时信息
                                tdw({
                                    opername: 'ppt_performance',
                                    module: 'switch_page',
                                    action: 'cost_time',
                                    ver6: JSON.stringify(this.costTime),
                                });
                            } else {
                                this.costTime.taskDuration = this.costTime.jsDuration;
                            }
                            console.log('PerformanceObserver-switch-page', this.costTime);
                        }
                        break;
                    }
                }
            });

            observer.observe({
                entryTypes: ['longtask', 'mark'],
            });
        }
    };

    private observeSlideIndexChange = (selectionService: ISelectionService) => {
        reaction(() => ({
            slideIndex: selectionService.currentSlideIndex,
        }), () => {
            selectionService.currentSlide
            && this.begin(
                selectionService.currentSlide.key,
                ElementsAnalyze.includeBaseElementCount(selectionService.currentSlide),
            );
        });
    };

    private begin(key, elementCount) {
        if (this.costTime.pageKey !== key) {
            // if (window.performance?.mark) {
            //     window.performance.mark('switchPageBegin');
            // }
            this.costTime = {
                pageKey: key,
                baseElementCount: elementCount,
                jsDuration: 0,
                taskDuration: 0,
            };
        }
    }
}
